import React from 'react';

export const CaCookiesContext = React.createContext<{
  token: string | null;
  apiUrl: string | null;
}>({
  token: null,
  apiUrl: null,
});
